export const DialogGroups = Object.freeze({
  crm: {
    activities: {
      confirmDeleteActivity: 'crm:activities:confirm-delete',
    },
  },
  dashboardEmails: {
    confirmIgnoreFuture: 'dashboardEmails:notice-center:confirm-ignore-future',
  },
} as const);
